import { FormDataBusinessInformation } from ".";
import { DEFAULT_PAYER_INDUSTRY } from "../../utils/industry";
import { getPhoneFormEmptyValues } from "../FormPartialPhoneNumber";

export const getBusinessFormEmptyValues = (
  country?: string
): FormDataBusinessInformation => ({
  legalBusinessName: "",
  dba: "",
  taxClassification: null,
  taxId: "",
  industry: DEFAULT_PAYER_INDUSTRY,
  email: "",
  usePersonalEmail: false,
  phone: getPhoneFormEmptyValues(country),
  website: "",
  noWebsite: false,
  numberOfEmployees: "None",
  address: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    postalCode: ""
  },
  canadaQuebecEnterpriseNumber: "",
  stateOfIncorporation: null,
  yearOfIncorporation: null
});
